import { Box, Button } from '@material-ui/core';
import React, { useState, useContext } from 'react';
import StyledModal from '../molecules/StyledModal';
import FormCard from './FormCard';
import FormMobile from './FormMobile';
import { NotificationModalContext } from '../../contexts/NotificationModalContext';

export default function ModalSwitchAccountant({
  tagFaqMobile,
  tagFaqMobileLigar,
  tagFaqMobileWpp,
  tagFaqMobileId,
  tagFaqMobileLigarId,
  tagFaqMobileWppId,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const { setOpenModal: setOpenConfirmSubmitModal } = useContext(NotificationModalContext);

  return (
    <>
      <Box style={{ padding: '12px 20px 50px' }}>
        <Button
          id={tagFaqMobileId}
          onClick={() => {
            tagFaqMobile()
            setModalOpen(true)}}
          variant="outlined"
          style={{
            border: 'none',
            width: '100%',
            backgroundColor: '#0CB49D',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#09796A',
            },
          }}
        >
          TROCAR DE CONTABILIDADE
        </Button>
      </Box>
      <StyledModal open={modalOpen} setOpen={setModalOpen}>
        <FormCard color="#0CB49D" title="Trocar contador">
          <FormMobile
            color="#0CB49D"
            hubspotAction="trocar-contador"
            onSuccess={() => setOpenConfirmSubmitModal(true)}
            originModal={setModalOpen}
            tagPhone={tagFaqMobileLigar}
            tagWhatsApp={tagFaqMobileWpp}
            tagPhoneId={tagFaqMobileLigarId}
            tagWhatsAppId={tagFaqMobileWppId}
          />
        </FormCard>

      </StyledModal>
    </>
  );
}
